/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DeviceMobilePortrait24Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 24, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DeviceMobilePortrait24Icon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M11 17H14V16H11V17Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17 6.5C17 5.67157 16.3284 5 15.5 5H9.5C8.67157 5 8 5.67157 8 6.5V17.5C8 18.3284 8.67157 19 9.5 19H15.5C16.3284 19 17 18.3284 17 17.5V6.5ZM15.5 6C15.7761 6 16 6.22386 16 6.5V17.5C16 17.7761 15.7761 18 15.5 18H9.5C9.22386 18 9 17.7761 9 17.5V6.5C9 6.22386 9.22386 6 9.5 6L15.5 6Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DeviceMobilePortrait24Icon.tags = [
  'mobile',
  'phone',
  'device',
  'touchscreen',
  'portrait',
];

DeviceMobilePortrait24Icon.category = '24x24';

DeviceMobilePortrait24Icon.iconSize = 24;
